import { jsx as _jsx } from "react/jsx-runtime";
import { PictureSource } from '../PictureSource/PictureSource';
export const PictureSources = ({ sources }) => {
    return sources.map((source) => _jsx(PictureSource, Object.assign({}, source), source.src));
};
PictureSources.displayName = 'PictureSources';
